import { useFeatureFlagEnabled } from "posthog-js/react";
import { useCurrentUser } from "./react-query/useCurrentUser";
import {
  getSmdMigrationAccessStatus,
  SmdMigrationAccessStatus,
} from "../utils/smdMigrationInterception";
import { POSTHOG_FEATURE_FLAGS } from "../services/posthogFeatureFlagDefinitions";

export const useSmdMigrationAccess = (): {
  status: SmdMigrationAccessStatus;
} => {
  const interceptionEnabled = useFeatureFlagEnabled(
    POSTHOG_FEATURE_FLAGS.SMD_MIGRATION_INTERCEPTION_ENABLED
  );
  const { data: profile, isLoading, isError } = useCurrentUser();

  // Do not mount protected medical flows while PostHog is still resolving the
  // rollout switch. An explicit false value is the pre-launch/kill-switch path.
  if (interceptionEnabled === undefined) return { status: "loading" };

  if (!interceptionEnabled) {
    return { status: "allowed" };
  }

  if (isLoading) return { status: "loading" };

  // Do not mount protected medical flows when we cannot determine whether the
  // authenticated user belongs to the migration cohort.
  if (isError && !profile) return { status: "unavailable" };

  return {
    status: getSmdMigrationAccessStatus({ profile, interceptionEnabled }),
  };
};
